import React from "react";
import CreonSurvey from "./fusion";
import CREON_CONTENT_UA from "./creonContentUa";
import { CREON_UA_COMPLETION_URLS, CREON_UA_IMAGE_URLS } from "./fusion-con-ua";

export default function FusionDoctorUkraineSurvey(props) {
  return (
    <CreonSurvey
      {...props}
      projectId="creon_consumers_ua_doc"
      segment="doc"
      questionnaireContent={CREON_CONTENT_UA}
      imageUrls={CREON_UA_IMAGE_URLS}
      completionUrls={CREON_UA_COMPLETION_URLS}
      languages={["ua"]}
      defaultLanguage="ua"
      initialLanguage="ua"
    />
  );
}
